<template>
  <van-cell-group class="mt-2 py-2" @click="shopinfo(seller.id)">
    <van-cell>
      <div class="text-base" slot="title">商家信息</div>
    </van-cell>
    <van-cell is-link>
      <template slot="title">
        <div class="text-gray-600 text-base">{{ seller.title }}</div>
        <div class="flex flex-row items-center">
          <van-icon name="location-o" />
          <div class="text-sm ml-1">{{ seller.address }} {{ seller.distance }}</div>
        </div>
      </template>
    </van-cell>
  </van-cell-group>
</template>
<script>
export default {
  props: {
    seller: {
      type: Object,
      default: () => {
        return {
          title: '',
          id: '',
          linker: '',
          type: '',
          distance: ''
        }
      }
    }
  }, // end of props
  methods: {
    shopinfo (id) {
      window.location.href = 'https://m.yooshifu.com/wujindian/' + id
    }
  }
}
</script>
